import './Features.scss';
import imgDatabase from '../../images/icons/database-cloud-circle.png';
import imgPlay from '../../images/icons/play-circle.png';
import imgPdf from '../../images/icons/file-pdf.png';
import imgMobile from '../../images/icons/smartphone.png';
import imgPaint from '../../images/icons/paint.png';
import imgDiagram from '../../images/icons/diagram.png';
import imgSolution from '../../images/icons/solution.png';
import imgSolution2 from '../../images/icons/solution2.png';

const Features = () => {
  return (
    <section id="features" className="features section">
      <div className="container">
        <header className="header">
          <h2 className="title">
            <span className="title-accent">핵심</span> 주요 기능
          </h2>
          {/* <p className="subtitle">매쓰테일러가 제공하는 강력한 솔루션</p> */}
          {/* <div className="description">
            <p>아래한 기반 디비구축의 독보적인 기술력을 가진 매쓰오토젠<span className='italic'>!</span></p>
            <p>방대한 기능의 집합체, 만물 백화점처럼 없는게 없는 문제은행 솔루션<span className='italic'>!</span></p>
            <p>정기 업데이트를 통해 더욱 강력하게 진화하면서 정확한 DB 구축을 지원합니다<span className='italic'>!</span></p>
          </div> */}
          {/* <div className="notice">
            <p>개발자가 개발에 전념하느라 사이트에 모든 내용을 담지 못한 점 양해 바랍니다.</p>
            <p>문의를 통해서 필요한 기능이 과연 없는지 확인해주세요.</p>
              <p>준비되어있는 선생님 처럼 준비된 개발자이기 때문에 자신있습니다.</p>
          </div> */}
          
        </header>

        <div className="grid">
          <article className="card">
            <div className="icon">
              <img src={imgDatabase} alt="Database Cloud" />
            </div>
            <h3 className="card-title">PDF를 HWP로 변환</h3>
            <p className="card-description">수학 수식이 포함된 PDF 파일을 HWP 형식으로 변환</p>
            <p className="card-description">빠른 타이핑 및 고퀄리티의 결과물을 제공</p>
            <p className="card-description">페이지당 30원의 국내 최저가</p>
          </article>

          <article className="card card--pro">
            {/* <span className="badge badge--pro">PRO</span> */}
            <div className="icon">
              <img src={imgDatabase} alt="PDF PRO" />
            </div>
            <h3 className="card-title">PDF를 HWP로 변환 PRO</h3>
            <p className="card-description">낙서 시험지 고급 분석</p>
            <p className="card-description">수식 로만체 표현 최적화</p>
            <p className="card-description">띄어쓰기 자동 교정</p>
            <p className="card-description">다단 레이아웃 자동 구분</p>
            <p className="card-description">40원/페이지</p>
          </article>

          <article className="card">
            {/* <span className="badge">무료</span> */}
            <div className="icon">
              <img src={imgSolution} alt="Solution" />
            </div>
            <h3 className="card-title">수학 문제 풀이 AI</h3>
            <p className="card-description">수학 문제를 AI가 자동으로 정답 및 풀이를 제공합니다.</p>
            <p className="card-description">변환된 문제를 HWP로 다운로드하여 활용할 수 있습니다.</p>
          </article>

          <article className="card">
            {/* <span className="badge">무료</span> */}
            <div className="icon">
              <img src={imgSolution2} alt="Solution 2" />
            </div>
            <h3 className="card-title">수학 문제 변형 AI</h3>
            <p className="card-description">수학 문제를 변환해서 쌍둥이 문제를 만들 수 있습니다.</p>
            <p className="card-description">변환된 문제를 HWP로 다운로드하여 활용할 수 있습니다.</p>
          </article>

          <article className="card">
            {/* <span className="badge">무료</span> */}
            <div className="icon">
              <img src={imgDiagram} alt="Diagram" />
            </div>
            <h3 className="card-title">수학 도형 그리기 AI</h3>
            <p className="card-description">퀄리티가 낮은 수학 도형 이미지를 고퀄리티로 새로 그려줍니다.</p>
            <p className="card-description">매쓰테일러 전용 그림판을 이용해서 쉽게 보정할 수 있습니다.</p>
          </article>

          <article className="card">
            {/* <span className="badge">무료</span> */}
            <div className="icon">
              <img src={imgPaint} alt="Paint" />
            </div>
            <h3 className="card-title">수학 도형 전용 그림판</h3>
            <p className="card-description">수학 도형을 쉽고 빠르게 그릴 수 있는 전용 그림판입니다.</p>
            <p className="card-description">배경에 이미지를 추가하여 도형을 쉽고 빠르게 똑같이 그릴 수 있습니다.</p>  
          </article>

        </div>
      </div>
    </section>
  );
};

export default Features;

